export const SET_PRODUITS = 'SET_PRODUITS';
export const SET_TOTAL_PRODUITS = 'SET_TOTAL_PRODUITS';
export const SET_BRIEF = 'SET_BRIEF';
export const CLEAR_BRIEF = 'CLEAR_BRIEF';
export const ADD_LIGNE_IN_PANIER = 'ADD_LIGNE_IN_PANIER';
export const DELETE_LIGNE_IN_PANIER = 'DELETE_LIGNE_IN_PANIER';
export const CLEAR_PANIER = 'CLEAR_PANIER';
export const SET_LOGO = 'SET_LOGO';
export const SET_REGROUPEMENT_PERSONNALISE = 'SET_REGROUPEMENT_PERSONNALISE';
export const SET_PLANNING_RESEAU_LC = 'SET_PLANNING_RESEAU_LC';
export const SET_PANIER = 'SET_PANIER';
export const SET_TYPE_DCF = 'SET_TYPE_DCF';
export const SET_USE_ECRAN_AJOUT = 'SET_USE_ECRAN_AJOUT';
